export default {
  getLogin: '/lx/manage/user/auth/login',
  getInfo: '/lx/manage/user/getUserInfo',
  getUpdata: '/lx/manage/user/password',
  getOut:`/lx/manage/user/logout`,
  QinwenLogin: (state) => `/lx/manage/user/qwcode?state=${state}`
}
